import {FC} from 'react'
import {useQuery} from 'hooks/graphql'
import Loading from 'components/Loading'
import {PREPARE_CSV_PROCEDURE_REQUEST} from './query'
import {Presenter} from './Presenter'

export const Index: FC = () => {
  const {data, loading, refetch, startPolling, stopPolling} = useQuery(PREPARE_CSV_PROCEDURE_REQUEST, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
  })

  const prepareCsvProcedureRequests = data?.client?.prepareCsvProcedureRequests || []

  return loading ? (
    <Loading />
  ) : (
    <Presenter
      prepareCsvProcedureRequests={prepareCsvProcedureRequests}
      refetch={refetch}
      startPolling={startPolling}
      stopPolling={stopPolling}
    />
  )
}
